import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { NoSpecialCharactersValidator } from 'src/app/shared/validators/special-characters/special-characters.validator';

import {
  DeviceNameCommands,
  DeviceNameProperties,
  FeatureCommands,
  FeaturePropertyKey,
} from '@vi-iot/client';
import { FeatureNames } from '@vi-iot/client';

import { InstallationFeaturesStore, RemoteDeviceStore } from '@store';
import { noWhitespaceValidator, uniqueNameValidator } from '@common';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'edit-device-name-modal',
  templateUrl: './edit-device-name-modal.component.html',
  styleUrls: ['./edit-device-name-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditDeviceNameModalComponent implements OnInit {
  allDevicesNamesInUse: string[] = [];
  deviceName: string;
  deviceId: string;
  nameHasSpecialCharacters: boolean;
  deviceNameForm: FormControl<string>;
  currentDeviceName: string;

  ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<EditDeviceNameModalComponent>,
    private remoteDeviceStore: RemoteDeviceStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.deviceId = this.data.deviceId;
    this.installationFeaturesStore
      .selectInstallationDeviceFeature<DeviceNameProperties, DeviceNameCommands>(
        FeatureNames.deviceName,
        this.deviceId
      )
      .subscribe((feature) => {
        this.currentDeviceName = feature?.properties?.name?.value;
      });
    this.initDeviceNameForm();
  }

  initDeviceNameForm(): void {
    this.remoteDeviceStore.namesInUse$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((namesInUse) => {
        this.allDevicesNamesInUse = [...namesInUse];
      });

    this.deviceNameForm = new FormControl<string>('', [
      Validators.required,
      noWhitespaceValidator(),
      Validators.maxLength(40),
      uniqueNameValidator(this.allDevicesNamesInUse),
      NoSpecialCharactersValidator(),
    ]);
  }

  onSaveDeviceName(): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.deviceName,
      this.deviceNameForm.value,
      FeaturePropertyKey.value,
      'name',
      FeatureCommands.setName,
      null,
      this.deviceId
    );

    this.onClose();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onClear(): void {
    this.deviceNameForm.setValue('');
  }
}
